export default function draggableShiftDropTarget($parse, $q) {
  'ngInject';

  return function link($scope, $element, $attrs) {
    const isActive = () => $attrs.draggableShiftDropTarget === 'true';
    const parsed = $parse($attrs.draggableShiftDropTargetOnDrop);
    $element[0].__dsDrop = (args) =>
      $q((resolve, reject) => {
        try {
          if (isActive()) {
            $scope.$evalAsync(() => {
              resolve(parsed($scope, { dropEl: $element, ...args }));
            });
          } else {
            resolve(false);
          }
        } catch {
          reject();
        }
      });
  };
}
